import StandsSimpleGrid from "./stands-simple-grid";


export default StandsSimpleGrid;